<script setup>
import { reactive, ref, watch } from "vue";
import { ElMessage } from "element-plus";
import { EFFLUENT_TREE } from "@/constants";
import PurPage from "./purPage.vue";
import SupPage from "./supPage.vue";

// 页面title
const title = ref("出水标准配置");

// 关键字
const filterText = ref("");

// 树loading
const treeLoading = ref(false);

const isEmpty = ref(true);

const purRef = ref(null);

const supRef = ref(null);

// 页面参数
const pageParams = reactive({
  type: 0,
});

// 树ref
const treeRef = ref(null);

// 树节点筛选
const filterNode = (value, data) => {
  if (!value) return true;
  return data.label.indexOf(value) !== -1;
};

// 树点击事件
const handleNodeClick = (data) => {
  if ([1, 2, 3, 4, 5, 6].includes(data.type)) {
    isEmpty.value = false;
    pageParams.type = data.type;
    if (data.type == 6) {
      setTimeout(() => {
        supRef.value.getData();
      }, 1);
      return;
    }
    // 保证purRef对象有值才执行
    setTimeout(() => {
      purRef.value.getData();
    }, 1);
  } else {
    isEmpty.value = true;
    ElMessage.warning("请选择具体执行标准!");
  }
};

// 净水标准保存回调
const purSubmit = () => {};

// 点击保存
const handleSave = () => {
  if (pageParams.type == 6) {
    supRef.value?.submitForm();
  } else {
    purRef.value?.submitForm();
  }
};

watch([() => filterText.value], ([newText]) => {
  treeRef.value.filter(newText);
});
</script>

<template>
  <zh-table-page v-bind="{ title }">
    <template #header-btn>
      <el-button
        type="primary"
        icon="CircleCheck"
        :disabled="isEmpty"
        @click="handleSave()"
        >保存</el-button
      >
    </template>
    <template #search></template>
    <template #left>
      <div v-loading="treeLoading">
        <el-input
          placeholder="输入关键字进行过滤"
          v-model.trim="filterText"
          clearable
        />
        <el-tree
          :data="EFFLUENT_TREE"
          node-key="id"
          :expand-on-click-node="false"
          :filter-node-method="filterNode"
          ref="treeRef"
          default-expand-all
          @node-click="handleNodeClick"
          highlight-current
        >
          <template #default="{ node }">
            <span class="custom-tree-node">
              <span>
                {{ node.label }}
              </span>
            </span>
          </template>
        </el-tree>
      </div>
    </template>
    <template #table>
      <el-empty
        v-show="isEmpty"
        :image="require('@/assets/images/none.png')"
        description="请选择具体执行标准"
        style="height: 100%"
        :image-size="200"
      />
      <div v-show="!isEmpty" class="form_box">
        <div v-if="[1, 2, 3, 4, 5].includes(pageParams.type)">
          <!-- 一级A标-一级B标、DB51标准（城镇-工业） -->
          <pur-page
            ref="purRef"
            :pageParams="pageParams"
            @afterSubmit="purSubmit"
          />
        </div>
        <div v-else-if="pageParams.type == 6">
          <!-- 生活饮用水标准 -->
          <sup-page ref="supRef" :pageParams="pageParams" />
        </div>
      </div>
    </template>
  </zh-table-page>
</template>

<style lang="scss" scoped>
.form_box {
  padding-top: 20px;
}
</style>
